import React from "react";
import { useDispatch, useSelector, useEf } from "react-redux";
import "./Header.css";
import { logout } from "../../../redux/actions/authActions";
import logo from "../../../assets/images/logo.png";
import whatsApp from "../../../assets/images/whatsApp.svg";
import facebook from "../../../assets/images/facebook.svg";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom'
import { getHomeData } from "../../../redux/actions/dataActions";

const maxMobileWidth = 767;

const Header = (props) => {

  const [inactiveTime, setInactiveTime] = useState(0);
  const dispatch = useDispatch();
  const { isAuthenticated, FirstName, LastName, user } = useSelector(
    (state) => state.auth
  );
  const { orders, data } = useSelector((state) => state.data);

  useEffect(() => {
    let timer;

    const resetTimer = () => {
      // Reset the timer on user activity
      setInactiveTime(0);
    };

    // Attach event listeners for user activity
    document.addEventListener('mousemove', resetTimer);
    document.addEventListener('keypress', resetTimer);

    // Timer to track inactive time
    if (isAuthenticated) {
      timer = setInterval(() => {

        setInactiveTime((prevInactiveTime) => prevInactiveTime + 1);

        // Check if inactive time exceeds your session timeout duration (in seconds)
        const sessionTimeout = 3600; // 1 hour in seconds

        if (inactiveTime >= sessionTimeout) {

          // Log out
          console.log('Session timeout. Logging out...');
          logoutFunc();
        }

      }, 1000); // Update every second
    }

    // Cleanup: Remove event listeners and clear the timer when component unmounts
    return () => {
      document.removeEventListener('mousemove', resetTimer);
      document.removeEventListener('keypress', resetTimer);
      clearInterval(timer);
    };
  }, [inactiveTime, isAuthenticated]);


  const negative = useNavigate();

  const logoutFunc = () => {
    dispatch(logout());
    window.location.replace("/");
    setInactiveTime(0);
  }

  const isMobile = window.innerWidth <= 760

  const handleChange = (e) => {
    dispatch(getHomeData(e.target.value))
  }


  return (
    <section className="header is-sticky">
      <a href="https://uti.co.il/" className="logo_link" target="_blank" rel="noopener noreferrer">
        <img src={logo} alt="logo" className="logo" />
      </a>
      {(isAuthenticated && !isMobile) ? (
        <div className="page_title">
          <a href="#status">תהליך הרכישה</a>
          <a href="#documents">מסמכים</a>
          <a href="#order-details">פרטי הזמנה</a>
        </div>
      ) : null}
      <div className="side-header">
        <div className="side-header-items">
          <span>884*</span>
          <a target="_blank" href="https://wa.me/972523122668" className="icon_link">
            <img src={whatsApp} alt="whatsApp" className="header-icon" />
          </a>
          {/*<a target="_blank" href="" className="icon_link">
            <img src={facebook} alt="facebook" className="header-icon"/>
          </a>*/}
          {isAuthenticated && <span className="logout" onClick={logoutFunc}>התנתקות</span>}
        </div>
      </div>

    </section>
  );
};

export default Header;
